import * as React from 'react';
import toast from 'cogo-toast';
import { Page, Card, Grid, Form, Button } from 'tabler-react';

import Request from '../../shared/request';
import PageComponent from '../PageComponent';

class Subscribe extends PageComponent {
  state = {
    isProcessing: false,
    promotion: true,
    upgrade: true,
  };

  async componentDidMount() {
    const data = await Request.post('emailSubscribe');
    const { promotion = true, upgrade = true } = data || {};
    this.setState({ promotion, upgrade });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isProcessing: true });
    const data = await Request.post('emailSubscribe', {
      subscribed: {
        promotion: this.state.promotion,
        upgrade: this.state.upgrade,
      },
    });
    if (data) {
      toast.success(' 邮件订阅更新成功');
    }
    this.setState({ isProcessing: false });
  };

  render() {
    return (
      <div className="page-content">
        <div className="container">
          <Grid.Row className="miao-setting">
            <Grid.Col>
              <Card title="邮件订阅设置">
                <Form onSubmit={this.handleSubmit}>
                  <Form.InputGroup>
                    <Form.Checkbox
                      checked={this.state.promotion}
                      label="促销信息"
                      name="promotion"
                      onChange={() => {
                        this.setState(prevState => ({
                          promotion: !prevState.promotion,
                        }));
                      }}
                    />
                  </Form.InputGroup>
                  <Form.InputGroup>
                    <Form.Checkbox
                      checked={this.state.upgrade}
                      label="产品更新日志"
                      onChange={() => {
                        this.setState(prevState => ({
                          upgrade: !prevState.upgrade,
                        }));
                      }}
                      name="upgrade"
                    />
                  </Form.InputGroup>
                  <Button
                    className="miao-setting-btn"
                    disabled={this.state.isProcessing}
                    loading={this.state.isProcessing}
                    type="submit"
                    color="primary"
                    value="Submit">
                    确认
              </Button>
                </Form>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </div>
      </div>
    );
  }
}

export default Subscribe;
